const SELECTORS = {
  uhfHeader: '#headerArea.uhf',
  pageHeader: '#site-header',
  meta: 'meta[name="theme-color"]'
}

class MetaColor {
  constructor (element) {
    this.uhfHeader = element
    this.pageHeader = document.body.querySelector(SELECTORS.pageHeader)
    this.meta = document.head.querySelector(SELECTORS.meta)
    this.registerObserver()
  }

  registerObserver() {
    const options = {
      root: null,
      threshold: 0
    }

    const observer = new IntersectionObserver((entries, observer) => this.uhfInView(entries, observer), options)
    observer.observe(this.pageHeader)
  }

  uhfInView(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.meta.setAttribute('content', '#ffffff')
      } else {
        this.meta.setAttribute('content', '')
      }
    })
  }
}

export default {
  selector: SELECTORS.uhfHeader,
  Source: MetaColor
}
